document.addEventListener("DOMContentLoaded", () => {
  const sideImages = document.querySelector(".main-product .side-images");
  const sideImagesButtons = document.querySelectorAll(
    ".main-product .side-images .thumbnail"
  );
  const productInfo = document.querySelector(".product-info");
  const mainImage = document.getElementById("MainImage");

  const updateSideImagesHeight = () => {
    if (window.innerWidth >= 990) {
      const productInfoHeight = productInfo.offsetHeight;
      sideImages.style.height = `${productInfoHeight}px`;

      sideImagesButtons.forEach((button) => {
        button.addEventListener("click", () => {
          setTimeout(updateSideImagesHeight, 100); // Adjust timeout as needed
        });
      });
    } else {
      sideImages.style.height = "auto";
    }
  };

  if (window.innerWidth >= 990) {
    updateSideImagesHeight();
  }

  window.addEventListener("resize", updateSideImagesHeight);

  const subNavRecommendations = document.querySelector(
    ".sub-nav .recommendations-link"
  );

  const subNavQuestions = document.querySelector(".sub-nav .questions-link");

  const recommendations = document.querySelector(".ed-product-slider-section");
  const questions = document.querySelector(".shopify-section.accordion");

  if (subNavRecommendations) {
    if (recommendations) {
      subNavRecommendations.addEventListener("click", () => {
        recommendations.scrollIntoView({ behavior: "smooth" });
      });
    } else {
      subNavRecommendations.remove();
    }
  }

  if (subNavQuestions) {
    if (questions) {
      subNavQuestions.addEventListener("click", () => {
        questions.scrollIntoView({ behavior: "smooth" });
      });
    } else {
      subNavQuestions.remove();
    }
  }
});
